import React from "react";
import ReactJson from "react-json-view";
import { StyledJsonWrapper } from "../styled";
import { DescriptionText } from "./DescriptionText";

export const JsonPreview = ({ data, collapseDepth = 1, emptyFallback = "No data." }) => {
  if (data === undefined || data === null) {
    return <DescriptionText>{emptyFallback}</DescriptionText>;
  }

  return (
    <StyledJsonWrapper>
      <ReactJson
        src={data}
        collapsed={collapseDepth}
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={false}
        name={false}
        collapseStringsAfterLength={60}
        style={{ fontSize: 12 }}
      />
    </StyledJsonWrapper>
  );
};


